import { Identifiable } from './identifiable';
import { BaseModel } from './base-model';

export class TemplateAccess implements Identifiable {
  id: string = null;
  owner: BaseModel = null;
  riskTemplates: Array<BaseModel> = [];
  riskAffectedDepartments: Array<BaseModel> = [];
  riskAffectedResources: Array<BaseModel> = [];
  riskAffectedSites: Array<BaseModel> = [];
  riskAffectedVendors: Array<BaseModel> = [];
  allTemplates: boolean = false;
  allDepartments: boolean = false;
  allResources: boolean = false;
  allSites: boolean = false;
  allVendors: boolean = false;

  constructor() {
  }
}
